module.exports = __webpack_public_path__ + "static/img/logo_43.62b96ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_43.png
// module id = GIf4
// module chunks = 1